export const advantages = [
  {
    id: "1",
    title: "Точный подбор под ваш бизнес",
    description: "Анализируем специфику вашего объекта и подбираем администраторов с релевантным опытом — от бюджетных хостелов до luxury-отелей.",
    icon: "ri-hotel-line",
  },
  {
    id: "2",
    title: "Полное обучение и адаптация",
    description: "Не просто находим — обучаем. Проводим трёхнедельную программу адаптации, чтобы сотрудник с первого дня работал на ваши стандарты.",
    icon: "ri-graduation-cap-line",
  },
  {
    id: "3",
    title: "Цифровизация процессов",
    description: "Внедряем CRM-системы для учёта клиентов, автоматизируем бронирования и отчётность. Ваши администраторы работают эффективнее.",
    icon: "ri-computer-line",
  },
  {
    id: "4",
    title: "Гарантия замены",
    description: "Если подобранный сотрудник не подошёл в течение 3 месяцев — бесплатно подберём замену без дополнительных вопросов.",
    icon: "ri-shield-check-line",
  },
  {
    id: "5",
    title: "Работа по СМК",
    description: "Разрабатываем и внедряем стандарты менеджмента качества. Помогаем пройти проверки и получить сертификаты.",
    icon: "ri-award-line",
  },
  {
    id: "6",
    title: "Экономия времени",
    description: "Весь процесс — от поиска до выхода на работу — занимает 2-3 недели вместо 2-3 месяцев при самостоятельном подборе.",
    icon: "ri-time-line",
  },
];